import { useBaseDataContext } from ".";;

export default function useGeneralCRUDDataContext<T extends { id: number|string }, G>({
    route,
    controller,
    mapperModelToDTO,
    mapperDTOToModel
} : { 
    route: string,
    controller: string,
    mapperModelToDTO: (model: T) => Partial<G>
    mapperDTOToModel: (dto: G) => T
}){
    const {
        getBaseResult,
        getBaseResultArray,
        putBaseResult,
        postBaseResult,
        deleteBaseBooleanResult,
    } = useBaseDataContext(route);

    const getAll = (params: any = undefined) => getBaseResultArray<T, G>({
        controller: `${controller}s`,
        params: params,
        mapperDTOToModel: mapperDTOToModel
    });

    const get = (id: number) => getBaseResult<T, G>({ 
        controller: controller, 
        params: { id: id }, 
        mapperDTOToModel: mapperDTOToModel 
    });

    const post = postBaseResult<T, G>({
        controller: controller,
        mapperModelToDTO: mapperModelToDTO,
        mapperDTOToModel: mapperDTOToModel
    });

    const put = putBaseResult<T, G>({
        controller: controller,
        mapperModelToDTO: mapperModelToDTO,
        mapperDTOToModel: mapperDTOToModel
    })

    const del = (model: Partial<T>) => deleteBaseBooleanResult({
        controller: controller,
        params: { id: model.id }
    });

    return { getAll, get, post, put, del };
}